"use strict";var r=(f=>(f.On="On",f.Before="Before",f.After="After",f))(r||{});export default r;
//# sourceMappingURL=MovePlacement.js.map
